export default "__VITE_ASSET__2pdqGsnf__"